<template>
    <modal @close="clearSelectedPerson" dialog="modal-lg" class="dark-top" :footer="false">
        <div slot="title">
            <h2>Agent details</h2>
            <h3 v-if="getSelectedPerson">{{ getSelectedPerson.brandName }}</h3>
        </div>

        <div slot="body">
            <tabs>
                <tab name="DETAILS">
                    <agent-edit :showButtons="false" :agent="tempSelectedPerson" @toggleIsDisabled="toggleIsDisabled" @formHaveErros="onFormHaveErrors"></agent-edit>
                </tab>
                <tab name="COMMISSIONS">
                    <commissions :showButtons="false" :passedForm="tempSelectedPerson" :isDisabled="isFormInvalid" @commissionsChanged="hasTabDataChanges = true"></commissions>
                </tab>
                <tab name="ADVANCED SETTINGS" v-if="showOtaAdvancedSettingsTab">
                    <ota-settings :agent="tempSelectedPerson" :otaChannelType="tempSelectedPerson.channelType" @otaSettingsChanged="hasTabDataChanges = true"></ota-settings>
                </tab>
            </tabs>

            <div class="d-flex justify-content-end align-items-center mb-4 p-3">
                <button class="btn cancel wider mr-3" @click="cancel">Cancel</button>
                <button class="btn green wider" @click="save" :disabled="isSaveDisabled">Save</button>
            </div>
        </div>
    </modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Modal from './Modal'
    import Empty from '../Empty'
    import AgentEdit from '@/components/people/agents/AgentEdit'
    import Overview from '@/components/people/agents/AgentOverview'
    import Commissions from '@/components/people/agents/AgentCommissionsWrapper'
    import OtaSettings from '@/components/people/agents/AgentOtaSettings'

    export default {
        mixins: [ ],
        data() {
            return {
                tempSelectedPerson: null,
                isDetailsSaveButtonDisabled: true,
                hasTabDataChanges: false,
                isFormInvalid: false
            }
        },
        created() {
            this.tempSelectedPerson = JSON.parse(JSON.stringify(this.getSelectedPerson));
        },
        computed: {
            ...mapGetters([
                'getSelectedPerson',
                'getUpdatingAgent'
            ]),
            showOtaAdvancedSettingsTab() {
                return !!(this.tempSelectedPerson && this.tempSelectedPerson.isOTA);
            },
            isSaveDisabled() {
                if (this.getUpdatingAgent) return true;
                if (this.isFormInvalid) return true;
                if (this.hasTabDataChanges) return false;
                return this.isDetailsSaveButtonDisabled;
            },
        },
        methods: {
            ...mapActions([
                'clearSelectedPerson',
                'updateClonedAgent',
                'updateNewAgentSetup',
                'closeModal',
                'updateAgent',
                'updateOtaAgentInfo',
                'getOTAByChannelType'
            ]),
            cancel() {
                this.closeModal();
            },
            save() {
                // If is OTA we use a different save method
                this.updateNewAgentSetup(this.tempSelectedPerson); // In case there is an error it has data to populate the new agent form
                this.updateClonedAgent(this.tempSelectedPerson);

                this.updateAgent({
                    agent: this.tempSelectedPerson
                });
            },
            toggleIsDisabled(isDisabled) {
                this.isDetailsSaveButtonDisabled = isDisabled;
            },
            onFormHaveErrors(hasErrors) {
                this.isFormInvalid = hasErrors;
            },
        },
        components: {
            Modal,
            Empty,
            AgentEdit,
            Overview,
            Commissions,
            OtaSettings
        }
    }
</script>

<style lang="scss">
    @import '../../assets/scss/_variables.scss';

    .tabs-component-tabs {
        margin: 0 1.5rem;
    }
</style>



// WEBPACK FOOTER //
// AgentView.vue?1877c085